import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
/**
 * Récupère la valeur d'un cookie par son nom
 * @param {string} name - Nom du cookie
 * @returns {string|undefined} Valeur du cookie ou undefined
 */
export function getCookie(name) {
  var _document$cookie$spli;
  return (_document$cookie$spli = document.cookie.split('; ').find(function (cookie) {
    return cookie.startsWith("".concat(name, "="));
  })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.split('=').slice(1).join('=');
}